import React from 'react';

// Stats component
export function StatsTab({ stats }) {
  if (!stats) {
    return <h2>System Stats</h2>;
  }

  return (
    <div>
      <h2>System Stats</h2>
      <ul>
        <li>Total users: {stats.total_users}</li>
        <li>Admin users: {stats.admin_users}</li>
        <li>Total decks: {stats.total_decks}</li>
        <li>Total cards: {stats.total_cards}</li>
        <li>Total canvases: {stats.total_canvases}</li>
      </ul>
    </div>
  );
} 